// extracted by mini-css-extract-plugin
module.exports = {"selectBtn":"MultiSelect_selectBtn__3rJrZ","selBtn":"MultiSelect_selBtn__1u-M0"};